
// const squareSize = 80;
const squareNumb = 8;

const wrap = document.querySelector('#js-hero-anim');
const animSquare = document.querySelector('#js-hero-anim .square');
const animImg = document.querySelector('.hero-section').dataset.animImage;

const setupAnimation = (wrap, squareNumb, animImg) => {
    return new Promise((resolve) => {
      for (let indexY = 0; indexY < squareNumb; indexY++) {
        for (let indexX = 0; indexX < squareNumb; indexX++) {
          const squareEl = document.createElement('div')
          squareEl.classList.add('square')
          squareEl.style.height = `${squareEl.offsetWidth}px`;
          wrap.appendChild(squareEl)
          squareEl.style.height = `${squareEl.offsetWidth}px`;

          window.addEventListener('resize', () => {
            squareEl.style.height = `${squareEl.offsetWidth}px`;
          })

          const squareImage = document.createElement('div')
          squareImage.classList.add('image')
          squareImage.style['background-image'] = `url(${animImg})`
          squareImage.style['background-position'] = `-${squareEl.offsetWidth * indexX}px -${squareEl.offsetHeight * indexY}px`
          squareEl.appendChild(squareImage)
          
          const squareGray = document.createElement('div')
          squareGray.classList.add('gray')
          squareEl.appendChild(squareGray)
        }
      }
      resolve(); // Resolve promise after all squares are created
  });
};

setupAnimation(wrap, squareNumb, animImg).then(() => {
    window.animationInitialised = true;
    let e = new Event("animationInitialised");
    window.dispatchEvent(e);
});

let mouseEvent = {clientX: 0, clientY: 0}

document.addEventListener('mousemove', (event) => {
  mouseEvent = event
});

let maskPercentInterv;
let maskPercent = 0

function enterLeave(isEnter) {
  const squareList = document.querySelectorAll('.square')
  clearInterval(maskPercentInterv)
  
  maskPercentInterv = setInterval(() => {
    const stepDiff = 4.0
    if (isEnter) {
      maskPercent += stepDiff;
      if (maskPercent >= 50) {
        maskPercent = 50;
        clearInterval(maskPercentInterv)
      }
    }
    else {
      maskPercent -= stepDiff;
      if (maskPercent <= 0) {
        maskPercent = 0;
        clearInterval(maskPercentInterv)
      }
    }
    document.documentElement.style.setProperty('--mask-percent', `${maskPercent}%`);
  }, 2)
}

wrap.addEventListener('mouseenter', (event) => {
  enterLeave(true);
});

wrap.addEventListener('mouseleave', (event) => {
    enterLeave(false);
});

const mousePosAnim = {clientX: 0, clientY: 0}
const smoothness = 0.1;

function animate() {
  requestAnimationFrame(animate);
  
  if (!mouseEvent) return;

  mousePosAnim.clientX += (mouseEvent.clientX - mousePosAnim.clientX) * smoothness;
  mousePosAnim.clientY += (mouseEvent.clientY - mousePosAnim.clientY) * smoothness;
  
  const squareList = document.querySelectorAll('.square')

  Array.from(squareList).forEach((squareItem) => {
    const rect = squareItem.getBoundingClientRect(); // Block coordinates
    const centerX = rect.left + rect.width / 2;  // Block center X
    const centerY = rect.top + rect.height / 2;  // Block center Y

    // Difference between mouse position and block center
    const deltaX = mousePosAnim.clientX - centerX;
    const deltaY = mousePosAnim.clientY - centerY;

    // Angle in radians and conversion to degrees
    const angleRad = Math.atan2(deltaX, deltaY);
    const angleDegImage = angleRad * (-180 / Math.PI);
    const angleDegGray = angleRad * (-180 +30 / Math.PI);
    const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2) / 20;
    
    squareItem.style.setProperty('--mask-distance', `${distance}%`);
    squareItem.children[0].style.setProperty('--mask-angle', `${angleDegImage}deg`);
    squareItem.children[1].style.setProperty('--mask-angle', `${angleDegGray}deg`);
    
 //    squareItem.children[1].style['mask-image'] = `linear-gradient(${angleDegImage}deg, transparent 0%, transparent ${distance}%, black ${distance}%, black 100%)`;
    
//     const angleDegGray = angleRad * (-180 / Math.PI);
//     squareItem.children[1].style['mask-image'] = `linear-gradient(${angleDegGray}deg, transparent 0%, transparent ${distance}%, black ${distance}%, black 100%)`;    
  })
}

animate();